import React from 'react';




//export const EventAdd = ({ newEvent, ...props }) => {
export class EventAdd extends React.Component {
    constructor({ props }) {
        super(props);
        this.state = {
            paramTitle: "Account",
            saveBadge: 'invisible',
            startdate: '',
            enddate: '',
            type: '',
            param1: '',
            comment: '',
            paramSelections: []
        }
        this.submit = this.submit.bind(this);
        this.updateParmTitle = this.updateParmTitle.bind(this);

        this.getAccounts();
    };

    //let date, type, param1, comment;

    submit = (e) => {
        e.preventDefault();

        if (this.state.type.value === "AcctCoverage") {
            this.saveEvent({
                startdate: this.state.startdate.value,
                enddate: this.state.enddate.value,
                Account: this.state.param1.value,
                comment: this.state.comment.value
            });

            this.state.startdate.value = this.state.enddate.value = this.state.type.value = this.state.param1.value = this.state.comment.value = '';
            this.setState({ saveBadge: 'visible' });
        }

        
    }

    updateParmTitle(event) {
        let param = '';
        if (event.target.value === 'Attendance') {
            param = 'Driver ID';
            this.getDrivers();
        }
        else if (event.target.value === 'AcctCoverage') {
            param = 'Account';
            this.getAccounts();
        }
        this.setState({ paramTitle: param });
        this.state.param1.value = '';
    };

    render() {
        return (
            <div className="form-container">
                <form onSubmit={this.submit} className="form black-container">
                    <label>
                        <h3>Add an event</h3>
                        <br />
                        <br />
                        <br />
                    </label>
                    <label>
                        Start Date: <br />
                        <input
                            id="startdate"
                            type="date"
                            required
                            ref={(input) => this.state.startdate = input}
                        />
                    </label>
                    <label>
                        End Date: <br />
                        <input
                            id="enddate"
                            type="date"
                            ref={(input) => this.state.enddate = input}
                        />
                    </label>
                    <label>
                        Type: <br />
                        <select required ref={(input) => this.state.type = input} onChange={(event) => this.updateParmTitle(event)} >
                            <option value="AcctCoverage">Account Coverage</option>
                            <option value="Attendance">Attendance</option>
                        </select>
                    </label>
                    <label>
                        {this.state.paramTitle}: <br />
                        <select required ref={(input) => this.state.param1 = input}>
                            {
                                this.state.paramSelections.map((ps, i) =>
                                    <option value={ ps.id }>{ ps.name }</option>
                            )
                        }
                        </select>
                    </label>
                    <label>
                        Comment: <br />
                        <input
                            id="comment"
                            type="text"
                            ref={(input) => this.state.comment = input}
                        />
                    </label>
                    <p class={this.state.saveBadge}><span class="badge rounded-pill bg-success">Success</span></p>
                    <input type="submit" value="SUBMIT" />
                </form>
            </div>
        )
    };


    async getAccounts() {
        const response = await fetch('utils/accounts');
        const data = await response.json();
        if (data === "") {
            console.log("blank");
        } else {
            this.setState({ paramSelections: JSON.parse(data[0]) });
        }

    }

    async getDrivers() {
        const response = await fetch('utils/drivers');
        const data = await response.json();
        if (data === "") {
            console.log("blank");
        } else {
            this.setState({ paramSelections: JSON.parse(data[0]) });
        }

    }

    async saveEvent(obj) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(obj)
        };
        const response = await fetch('utils/saveacctcov', requestOptions);
        const data = await response.json();
        if (data === "") {
            console.log("blank");
        } 

    }
}